module.exports = __webpack_public_path__ + "static/img/zjsyf.c34709f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/zjsyf.png
// module id = YPfp
// module chunks = 0